class FaqSection {
  constructor(element) {
    this.element = element;
    this._attachListeners();
  }

  onBlockSelect(event) {
    this._openItem(event.target);
  }

  onBlockDeselect(event) {
    this._closeItem(event.target);
  }

  _getHeaderHeight() {
    let headerHeight = 0;
    
    const cssHeaderHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    if (cssHeaderHeight) {
      headerHeight = parseInt(cssHeaderHeight);
    }
    
    if (!headerHeight) {
      const header = document.querySelector('.header-section');
      if (header) {
        headerHeight = header.offsetHeight;
        
        const isHeaderPinned = document.body.classList.contains('header-pinned');
        const isHeaderScrolled = header.classList.contains('header-scrolled');
        
        if (isHeaderPinned || isHeaderScrolled) {
          headerHeight += 20;
        }
      }
    }
    
    return Math.max(headerHeight, 80);
  }

  _attachListeners() {
    FoxTheme.utils.addEventDelegate({
      context: this.element,
      event: 'click',
      selector: '.Faq__Question',
      handler: this._toggleItem.bind(this)
    });

    FoxTheme.utils.addEventDelegate({
      context: this.element,
      event: 'click',
      selector: '.FaqSummary__Link',
      handler: this._handleSummaryClick.bind(this)
    });
  }

  _handleSummaryClick(event, target) {
    event.preventDefault();
    
    const summaryItem = target.closest('.FaqSummary__Item');
    if (summaryItem) {
      summaryItem.classList.add('is-active');
      
      const siblings = Array.from(summaryItem.parentNode.children).filter(el => el !== summaryItem);
      siblings.forEach(item => item.classList.remove('is-active'));
    }

    const href = target.getAttribute('href');
    if (href && href.startsWith('#')) {
      const targetId = href.substring(1);
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        const headerHeight = this._getHeaderHeight();
        
        const additionalOffset = parseInt(target.dataset.offset) || 20;
        const totalOffset = headerHeight + additionalOffset;
        
        const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - totalOffset;
        
        window.scrollTo({
          top: Math.max(0, targetPosition), // Ensure we don't scroll above page top
          behavior: FoxTheme.config.motionReduced ? 'auto' : 'smooth'
        });
      }
    }
  }

  _toggleItem(event, target) {
    event.preventDefault();
    const item = target.closest('.Faq__Item');

    if (item.getAttribute('aria-expanded') === 'true') {
      this._closeItem(item);
    } else {
      this._openItem(item);
    }
  }

  _openItem(item) {
    const answerWrapper = item.querySelector('.Faq__AnswerWrapper');
    
    answerWrapper.style.height = 'auto';
    const fullHeight = answerWrapper.scrollHeight + 'px';
    answerWrapper.style.height = '0';
    
    answerWrapper.offsetHeight;
    
    item.setAttribute('aria-expanded', 'true');
    answerWrapper.setAttribute('aria-hidden', 'false');
    
    answerWrapper.style.height = fullHeight;
    
    const siblings = Array.from(item.parentNode.children).filter(el => 
      el !== item && el.classList.contains('Faq__Item') && el.getAttribute('aria-expanded') === 'true'
    );
    
    siblings.forEach(siblingItem => {
      this._closeItem(siblingItem);
    });
  }

  _closeItem(item) {
    const answerWrapper = item.querySelector('.Faq__AnswerWrapper');
    
    item.setAttribute('aria-expanded', 'false');
    answerWrapper.setAttribute('aria-hidden', 'true');
    
    answerWrapper.style.height = '0';
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const faqSections = document.querySelectorAll('[data-section-type="faq"]');
  faqSections.forEach(section => {
    const instance = new FaqSection(section);
    section.faqInstance = instance;
  });
});

document.addEventListener('shopify:section:load', function(event) {
  const faqSection = event.target.querySelector('[data-section-type="faq"]');
  if (faqSection) {
    const instance = new FaqSection(faqSection);
    faqSection.faqInstance = instance;
  }
});

document.addEventListener('shopify:block:select', function(event) {
  const faqSection = event.target.closest('[data-section-type="faq"]');
  if (faqSection && faqSection.faqInstance) {
    faqSection.faqInstance.onBlockSelect(event);
  }
});

document.addEventListener('shopify:block:deselect', function(event) {
  const faqSection = event.target.closest('[data-section-type="faq"]');
  if (faqSection && faqSection.faqInstance) {
    faqSection.faqInstance.onBlockDeselect(event);
  }
}); 